import { Typography } from '@mui/material';
import { useEmployeeNamesService } from 'domain/shared/employee';
import { useAsyncValue } from 'framework/utils';
import { getOwnerDisplayName } from '../utils';

const OwnerNameLabel = ({ owner }: { owner: string }) => {
  const { getEmployeeNameDataById } = useEmployeeNamesService();
  const employeeName = useAsyncValue(() => getEmployeeNameDataById(owner), [owner]);

  return (
    <Typography variant="body1" color="textSecondary" noWrap>
      {getOwnerDisplayName(owner, employeeName)}
    </Typography>
  );
};

export default OwnerNameLabel;
